<template>
  <div ref="rule">
    <a-modal
      wrapClassName="ruleModal"
      :getContainer="()=> $refs.rule"
      centered
      okText="确定"
      :width="960"
      :closable="false"
      :maskClosable="false"
      :cancelButtonProps="{style: { display: 'none' }}"
      :visible="rulePopVisible && !ISPRERENDER"
      :bodyStyle="bodyStyle"
      @ok="submit"
    >
      <template slot="title">
        <span class="title">选择证件照规格</span>
      </template>
      <a-tabs
        :activeKey="activeKey"
        @change="tabsCallback"
        @prevClick="callback"
        @nextClick="callback"
      >
        <a-tab-pane v-for="(item,idx) in ruleList" :tab="item" :key="idx"></a-tab-pane>
      </a-tabs>
      <div class="rule-lump">
        <div class="rule-fliter">
          <div class="fliter-ipt">
            <a-input-search
              @change="searchRule"
              v-model="searchVal"
              type="text"
              placeholder="输入规格名称搜索，如：一寸"
            />
          </div>
          <a-spin wrapperClassName="spin" :spinning="spinning" :delay="delayTime" tip="加载中...">
            <div class="scroll-wrp">
              <div class="fliter-items">
                <div
                  v-if="autoSpec&&(!searchVal)"
                  :class="`rule-item ${selRuleNum==-1?'active':''}`"
                  @click="selRule(-1)"
                >
                  <img class="rule-img" src="../assets/rule.png" alt />
                  <div class="rule-title">自定义规格</div>
                </div>
                <div
                  :class="`rule-item ${selRuleNum==idx?'active':''}`"
                  @click="selRule(idx,item)"
                  v-for="(item,idx) in ruleItemList"
                  :key="idx"
                >
                  <img class="rule-img" src="../assets/rule.png" alt />
                  <div :title="item.name" class="rule-title">{{item.name || item.searchName}}</div>
                  <div
                    v-if="item.width_px ||item.height_px"
                    class="rule-size"
                  >{{item.width_px}} × {{item.height_px}}px</div>
                </div>
              </div>
            </div>
          </a-spin>
        </div>
        <a-form :form="form" v-if="autoSpec&&(!searchVal)&&(selRuleNum == -1)" class="rule-info">
          <div class="title">自定义规格</div>
          <div class="setRule-item">
            <div class="label">像素大小</div>
            <div class="setRule-iptWrap">
              <a-form-item class="form-item">
                <a-input-number
                  :min="0"
                  @blur="onBlur"
                  placeholder="宽"
                  maxlength="4"
                  v-decorator="['widthVal',{ rules: [{ required: true, message: '请输入宽！' }] }]"
                  style="width: 64px;text-align: center"
                />
              </a-form-item>
              <span class="symbol">×</span>
              <a-form-item class="form-item">
                <a-input-number
                  :min="0"
                  @blur="onBlur"
                  placeholder="高"
                  maxlength="4"
                  v-decorator="[
          'heightVal',
          { rules: [{ required: true, message: '请输入高！' }] },
        ]"
                  style="width: 64px;text-align: center"
                />
              </a-form-item>
              <span class="unit">px</span>
            </div>
          </div>
          <div class="setRule-item">
            <div class="label">文件大小</div>
            <div class="setRule-iptWrap">
              <a-form-item class="form-item">
                <a-input-number
                  :min="0"
                  @blur="onBlur"
                  placeholder="最小"
                  maxlength="4"
                  v-decorator="[
          'fileMin',
          { rules: [{ required: true, message: '请输入最小值！' }] },
        ]"
                  style="width: 64px;text-align: center"
                />
              </a-form-item>
              <span class="symbol">～</span>
              <a-form-item class="form-item">
                <a-input-number
                  :min="0"
                  @blur="onBlur"
                  placeholder="最大"
                  maxlength="4"
                  v-decorator="['fileMax',{ rules: [{ required: true, message: '请输入最大值！' }] },]"
                  style="width: 64px;text-align: center"
                />
              </a-form-item>
              <span class="unit">kb</span>
            </div>
          </div>
          <div class="setRule-item">
            <div class="label">分辨率</div>
            <div class="setRule-iptWrap">
              <a-form-item class="form-item">
                <a-input-number
                  :min="0"
                  @blur="onBlur"
                  placeholder="300"
                  maxlength="4"
                  v-decorator="['dpi',{ rules: [{ required: true, message: '请输入dpi！' }] }]"
                  style="width: 64px;text-align: center"
                />
              </a-form-item>
              <span class="unit">dpi</span>
            </div>
          </div>
        </a-form>
        <div v-else-if="(ruleItemList.length != 0) && (ruleItemInfo.spec_id)" class="rule-info">
          <div class="title">{{ruleItemInfo.name}}</div>
          <div class="rule-info-item">
            <span>冲印尺寸</span>
            <span>{{ruleItemInfo.width_mm}}mm × {{ruleItemInfo.height_mm}}mm</span>
          </div>
          <div class="rule-info-item">
            <span>像素大小</span>
            <span>{{ruleItemInfo.width_px}}px × {{ruleItemInfo.height_px}}px</span>
          </div>
          <div class="rule-info-item">
            <span>分辨率</span>
            <span>{{ruleItemInfo.dpi}}dpi</span>
          </div>
          <div class="rule-info-item">
            <span>背景色</span>
            <span class="bg-item">
              <i
                v-for="(bgItem ,bgIdx) in ruleItemInfo.background_color"
                :key="bgIdx"
                :class="bgItem.color_name == 'white' && 'whiteBorder'"
                :style="{backgroundImage:`linear-gradient(to bottom,#${bgItem.s_color},#${bgItem.e_color})`}"
              ></i>
              <!-- `background-image:linear-gradient(to bottom,#${bgItem.s_color},#${bgItem.e_color})` -->
            </span>
          </div>
          <div class="rule-info-item">
            <span>文件大小</span>
            <span>{{ruleItemInfo.file_size}}</span>
          </div>
          <div class="rule-info-item">
            <span>文件格式</span>
            <span>{{ruleItemInfo.photo_format}}</span>
          </div>
        </div>
        <div v-else class="rule-info"></div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { debounce } from "../utils/utils";
import { getSearchSpecs, getSpecsItem } from "@/utils/api";
export default {
  props: {
    rulePopVisible: Boolean,
    autoSpec: {
      type: Boolean,
      default: true
    },
    ok: Function
  },
  data() {
    return {
      ISPRERENDER: null,
      value: "",
      value1: null,
      searchVal: null,
      spinning: false,
      delayTime: 500,
      selRuleNum: -1,
      bodyStyle: {
        padding: 0
      },
      activeKey: 0,
      ruleList: ["热门搜索"],
      hotRuleList: [
        "计算机等级考试",
        "教师资格证",
        "司法考试",
        "一寸",
        "二寸",
        "四六级",
        "电子导游证",
        "普通话",
        "国考",
        "社保证",
        "小一寸",
        "美国签证",
        "会计",
        "港澳通行证",
        "建造师",
        "日本签证",
        "简历",
        "驾驶证",
        "小二寸",
        "海外申请护照在线预约"
      ],
      ruleItemList: [],
      ruleItemInfo: {},
      list: [1, 2, 0],
      customizeRule: {}
    };
  },
  beforeCreate() {},
  created() {
    // 是否为预渲染,是预渲染则不展示弹窗防止将弹窗DOM渲染到静态页面，
    this.ISPRERENDER = window.__ISPRERENDER__;
    this.form = this.$form.createForm(this, { name: "validate_other" });
    // input防抖初始化
    this.searchRule = debounce(this.searchRuleFn, 500, { context: this });
    this.showhotRule();
  },
  methods: {
    callback() {},
    showhotRule() {
      this.hotRuleList.forEach((item, idx) => {
        this.ruleItemList[idx] = { searchName: item };
      });
    },
    tabsCallback(key) {
      this.activeKey = key;
      this.ruleItemList = [];
      this.ruleItemInfo = {};
      if (key == 0) {
        this.ruleItemList = [];
        this.searchVal = "";
        this.selRuleNum = -1;
        this.hotRuleList.forEach((item, idx) => {
          this.ruleItemList[idx] = { name: item };
        });
        // this.ruleItemList = this.hotRuleList.map(item => {
        //   console.log(item)
        // });
      }
      // if ([key == 0, this.autoSpec && key == 1].includes(true)) {
      //   this.searchVal = "";
      //   this.ruleItemList = [];
      //   return;
      // } else {
      //   this.searchVal = this.ruleList[key];
      //   this.searchRuleFn();
      // }
    },
    async searchRuleFn() {
      this.ruleItemList = [];
      this.ruleItemInfo = {};
      this.selRuleNum = 0;
      // 去除空格
      this.searchVal = this.searchVal.replace(/\s+/g, "");
      if (this.searchVal != "") {
        this.spinning = true;
        const specsData = (await getSearchSpecs(this.searchVal)).specs;
        this.spinning = false;
        this.ruleItemList = specsData;
        this.selRule(0, this.ruleItemList[0]);
      } else {
        this.selRuleNum = -1;
        this.showhotRule();
      }
    },
    handleFileSize(max, min) {
      let file_size = null;
      [max, min].every(item => item) &&
        (file_size = `${parseInt(+min / 1024)}~${parseInt(+max / 1024)}KB`);
      [max, min].every(item => !item) && (file_size = `无要求`);
      [max, min].some(item => item) &&
        (file_size = min
          ? `不小于${parseInt(+min / 1024)}KB`
          : `不大于${parseInt(+max / 1024)}KB`);
      return file_size;
    },
    async selRule(idx, param) {
      if (param && param.spec_id) {
        this.selRuleNum = idx;
        const specsData = (await getSpecsItem(param.spec_id)).result;
        // console.log(specsData);
        [
          specsData.width_px,
          specsData.height_px,
          specsData.width_mm,
          specsData.height_mm
        ].forEach(item => {
          item == null && (item = "无要求");
        });
        specsData.dpi == null && (specsData.dpi = 300);
        specsData.background_color = JSON.parse(specsData.background_color).map(
          item => {
            return {
              ...item,
              s_color: item.start_color.toString(16).padStart(6, 0),
              e_color: item.enc_color.toString(16).padStart(6, 0)
            };
          }
        );
        specsData.file_size = this.handleFileSize(
          specsData.file_size_max,
          specsData.file_size_min
        );
        specsData.spec_id = param.spec_id;
        this.ruleItemInfo = specsData;
      }
      if (idx == -1) {
        this.selRuleNum = -1;
      }
      if (param && param.searchName) {
        // this.activeKey = 1;
        this.searchVal = param.searchName;
        this.searchRuleFn();
      }
    },
    onChange(e) {
      const { value } = e.target;
      const reg = /^-?(0|[1-9][0-9]*)(\.[0-9]*)?$/;
      if ((!isNaN(value) && reg.test(value)) || value === "" || value === "-") {
        this.value = value;
      }
    },
    onBlur() {
      const { value, onChange } = this;
      if (value.charAt(value.length - 1) === "." || value === "-") {
        onChange({ value: value.slice(0, -1) });
      }
    },
    // '.' at the end or only '-' in the input box.
    submit(e) {
      this.ruleItemInfo.spec_id
        ? (sessionStorage.setItem(
            "ruleItemInfo",
            JSON.stringify(this.ruleItemInfo)
          ),
          this.ok())
        : this.form.validateFields((err, values) => {
            // console.log(err, values);
            let { widthVal, heightVal, fileMin, fileMax, dpi } = values;
            if (Object.keys(values).length == 0) {
              this.$notification["error"]({
                message: "规格错误",
                description: "请选择规格"
              });
              return;
            }
            if (+widthVal < 70 || +widthVal > 1200) {
              this.$notification["error"]({
                message: "自定义规格错误",
                description: "照片宽度必须在70~1200px"
              });
              return;
            }
            if (+heightVal < 100 || +heightVal > 1600) {
              this.$notification["error"]({
                message: "自定义规格错误",
                description: "照片高度必须在100~1600px"
              });
              return;
            }
            if (+widthVal / +heightVal > 1 || +widthVal / +heightVal < 0.5) {
              this.$notification["error"]({
                message: "自定义规格错误",
                description: "照片宽高比要在0.5~1"
              });
              return;
            }
            if (+fileMin > 5120) {
              this.$notification["error"]({
                message: "自定义规格错误",
                description: "文件最小值不能超过5120KB"
              });
              return;
            }
            if (+fileMax > 5120) {
              this.$notification["error"]({
                message: "自定义规格错误",
                description: "文件最小值不能超过5120KB"
              });
              return;
            }
            if (fileMin && fileMax && +fileMax < +fileMin) {
              this.$notification["error"]({
                message: "自定义规格错误",
                description: "文件最大值不能小于最小值"
              });
              return;
            }
            if (+dpi > 600) {
              this.$notification["error"]({
                message: "自定义规格错误",
                description: "dpi不能大于600"
              });
              return;
            }
            if (!err) {
              // specsData.dpi == null && (specsData.dpi = 300);
              sessionStorage.setItem(
                "ruleItemInfo",
                JSON.stringify({
                  width_px: widthVal,
                  height_px: heightVal,
                  file_size_min: fileMin,
                  file_size_max: fileMax,
                  dpi
                })
              );
              this.ok();
              // console.log("Received values of form: ", values);
            }
          });
    }
  }
};
</script>
<style scoped>
.rule-lump {
  width: 960px;
  display: flex;
  justify-content: space-between;
  background: #f5f7fa;
}
.rule-fliter {
  width: 677px;
  height: 458px;
  margin: 2px auto 0 auto;
  overflow: hidden;
}
.fliter-ipt {
  padding: 11px 14px;
  background: #ffffff;
}
.fliter-items {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  position: relative;
}
.spin {
  height: calc(100% - 54px);
}
.scroll-wrp {
  width: 694px;
  height: 100%;
  overflow-y: scroll;
  padding: 16px 16px 16px 8px;
}

.rule-item {
  width: 154px;
  height: 154px;
  border-radius: 2px;
  margin-bottom: 11px;
  padding: 0 10px;
  background: #ffffff;
  text-align: center;
  border: 2px solid #ffffff;
  cursor: pointer;
}
.rule-item.active {
  border: 2px solid #438bf9;
}
.rule-item:last-child:nth-child(4n + 3) {
  margin-right: calc(((100% - 154px * 4) / 3 + 154px) * 1);
}
.rule-item:last-child:nth-child(4n + 2) {
  margin-right: calc(((100% - 154px * 4) / 3 + 154px) * 2);
}
.rule-img {
  width: 56px;
  height: 56px;
  margin: 28px auto 13px auto;
}
.rule-title {
  color: #000000;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rule-size {
  font-size: 12px;
  color: #cacbce;
}
.rule-info {
  width: 277px;
  height: 458px;
  padding: 40px;
  background: #ffffff;
}
.rule-info .title {
  color: #303133;
  margin-top: 40px;
  margin-bottom: 39px;
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
}
.rule-info-item {
  font-size: 13px;
  color: #303133;
  margin: 14px 0;
  display: flex;
  justify-content: space-between;
}
.bg-item {
  display: flex;
  align-items: center;
}
.bg-item i {
  width: 12px;
  height: 12px;
  margin: 0 3px;
  border-radius: 50%;
}
.whiteBorder {
  border: 1px solid #ccc;
}
.setRule-iptWrap {
  margin-bottom: 18px;
}
.label {
  margin-bottom: 6px;
  font-size: 12px;
}
.form-item {
  width: 60px;
  display: inline-block;
}
.symbol {
  width: 13px;
  margin: 0 10px;
  font-size: 13px;
  color: #2a292e;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: bold;
  display: inline-block;
  text-align: center;
}
.unit {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #303133;
  margin-left: 16px;
  margin-top: 10px;
  display: inline-block;
}
.subTitle {
  color: #438bf9;
  font-size: 12px;
  float: right;
  cursor: pointer;
}
</style>
